import StackedBarChart from './stackedBarChart.js';
export default StackedBarChart;
